export default __webpack_public_path__ + "static/media/regulatory--end-of-no-heavy-goods-vehicles--g1.11347c2b.png";